export default __webpack_public_path__ + "3c97de6d0a39a1b25f0d9a946590d4e6.png";